import { useState } from "react";

// Prompt 21 — pick which FreshBooks business this LF company uses (multi-business logins).
export default function FreshBooksPicker({ businesses, picking, onSelect }) {
  const [chosen, setChosen] = useState("");
  return (
    <div className="mt-4 border border-neutral-900 p-3" data-testid="fb-picker-row">
      <div className="label-mini">pick a freshbooks business</div>
      <div className="flex items-center gap-2 mt-2">
        <select
          className="flex-1 border border-neutral-900 px-2 py-1.5 font-mono text-sm"
          value={chosen}
          onChange={(e) => setChosen(e.target.value)}
          data-testid="fb-business-select"
        >
          <option value="">— select —</option>
          {businesses.map((b) => (
            <option key={b.account_id} value={b.account_id}>{b.name}</option>
          ))}
        </select>
        <button type="button" className="btn-primary text-xs" disabled={!chosen || picking}
                onClick={() => onSelect(chosen)} data-testid="fb-business-set">
          {picking ? "setting…" : "set business"}
        </button>
      </div>
    </div>
  );
}
